import React, { useEffect, useState } from "react";
import Head from "next/head";
import HeroSection from "../components/Neet-ug/HeroSection";
import Explore from "../components/Neet-ug/Explore";
import Overview from "../components/Neet-ug/Overview";
import BlogsVisible from "../components/Neet-ug/blogsVisible";
import Plans from "../components/Neet-ug/Plans";
import TestimonialCarousel from "@/components/Neet-ug/TestimonialCarousel";
import Faqs from "@/components/Neet-ug/faq";
import BlackFridayOffer from "../components/Neet-ug/BlackFridayOffer";
import OneToOneSession from "../components/OneToOneSessionModal";
import axios from "axios";

export default function NeetUgPage() {
  const [priceBasic, setPriceBasic] = useState(1980);
  const [showOneToOneModal, setShowOneToOneModal] = useState(false);

  const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

  const fetchPricingData = async (API_URL) => {
    const endpoints = [
      `${API_URL}/api/fetch-services-data`,
    ];

    for (const endpoint of endpoints) {
      try {
        const res = await axios.get(endpoint);

        if (res?.data?.data?.length > 0) {
          return res;
        }
      } catch (error) {
        console.error("Pricing fetch error:", error);
      }
    }

    return null;
  };

  useEffect(() => {
    async function fetchPricing() {
      try {
        if (!API_URL) return;

        const res = await fetchPricingData(API_URL);

        if (res?.data?.data?.length > 0) {
          const fetched = res.data.data[0];

          setPriceBasic(
            fetched?.priceDetails?.basic || 1980
          );
        }
      } catch (err) {
        console.error("Pricing error:", err);
      }
    }

    fetchPricing();
  }, [API_URL]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOneToOneModal(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Head>
        <title>
          NEET UG Counselling 2026 | MBBS/BDS Admission, Cutoff, Seat Matrix
        </title>

        <meta
          name="description"
          content="Get complete NEET UG Counselling 2026 guidance for MBBS, BDS and AYUSH admission. Check cutoff, seat matrix, college predictor, choice filling, fees, bond, stipend and document support."
        />

        <meta
          name="keywords"
          content="NEET UG counselling 2026, NEET counselling, MBBS admission 2026, BDS admission, AYUSH counselling, NEET cutoff, NEET seat matrix, NEET college predictor, NEET rank predictor, MCC counselling, state counselling, NEET choice filling, MBBS counselling guidance"
        />

        <meta name="robots" content="index, follow" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />

        <meta charSet="utf-8" />

        <link
          rel="canonical"
          href="https://neetsupport.com/neet-ug"
        />

        {/* Open Graph SEO */}
        <meta property="og:type" content="website" />

        <meta
          property="og:title"
          content="NEET UG Counselling 2026 | MBBS/BDS Admission Guidance"
        />

        <meta
          property="og:description"
          content="Plan your NEET UG counselling with expert guidance, college predictor, cutoff analysis, seat matrix, fee, bond, stipend and choice filling support."
        />

        <meta
          property="og:url"
          content="https://neetsupport.com/neet-ug"
        />

        <meta
          property="og:site_name"
          content="NEET Support"
        />

        <meta
          property="og:image"
          content="https://neetsupport.com/og-image.webp"
        />

        {/* Twitter SEO */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="NEET UG Counselling 2026 | MBBS/BDS Admission Guidance"
        />

        <meta
          name="twitter:description"
          content="Complete NEET UG counselling support for MBBS, BDS and AYUSH admission with cutoff, seat matrix, college predictor and choice filling guidance."
        />

        <meta
          name="twitter:image"
          content="https://neetsupport.com/og-image.webp"
        />

        {/* Structured Data SEO */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "EducationalOrganization",
              name: "NEET Support",
              url: "https://neetsupport.com",
              logo: "https://neetsupport.com/favicon/neetsupport-logo.webp",
              description:
                "NEET Support provides NEET UG counselling guidance, college prediction, cutoff analysis, seat matrix insights, choice filling strategy and MBBS admission support.",
              sameAs: [
                "https://www.instagram.com/neetsupportindia/",
                "https://www.youtube.com/@NEETSupportIndia",
                "https://www.linkedin.com/company/neetsupport/",
                "https://www.facebook.com/NEETSupport.comIND",
              ],
            }),
          }}
        />
      </Head>

      <main className="mt-4">
        <OneToOneSession
          isOpen={showOneToOneModal}
          onClose={() => setShowOneToOneModal(false)}
        />

        {/* HERO SECTION */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <HeroSection />
        </div>

        {/* EXPLORE TOOLS */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <Explore />
        </div>

        {/* PLANS */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <Plans />
        </div>

        {/* OVERVIEW */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <Overview />
        </div>

        {/* TESTIMONIALS */}
        {/*
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <TestimonialCarousel />
        </div>
        */}

        {/* BLOGS */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <BlogsVisible />
        </div>

        {/* FAQS */}
        <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <Faqs />
        </div>
      </main>
    </>
  );
}